/* main.js */
// Can also be used with $(document).ready()
initMobileFlexsliders = function(window_width){
  var el = $('#header-offers.flexslider');

  if( window_width < 768 && typeof el.data('flexslider') == 'undefined' ){
    el.flexslider({
      animation: "fade",
      directionNav: false,
      controlNav: false
    });
  }
  else if(window_width > 767 && typeof el.data('flexslider') != 'undefined'){
    /* There is no slider.destroy() feature yet so we'll have to remove the element and recreate it */
    el.before('<div id="element_temp" class="flexslider"></div>');
    el.remove();
    $('#element_temp').html(window.header_offers_flex_base_html);
    $('#element_temp').attr('id', 'header-offers');
  }
};

mobileSurroundMargin = function(){
  header_h = $("#header").innerHeight() - 1; /* Minus the bottom border */
  surround_margin_top = $('#surround').css('margin-top');

  if(window.body_width < 767 && header_h != surround_margin_top){
    $('#surround').css('margin-top', header_h);
  }
  else if(window.body_width > 767 && surround_margin_top != 0){
    $('#surround').css('margin-top', 0 + 'px');
  }
};

pulldownClick = function(event){
  if (window.body_width > 767){
    // Get the target of the click event
    target = event.target;
    if ($(target).hasClass("main-nav-anchor")){
      // Get the ID of the parent li so we can get the correct pulldown menu if it exists
      id = $(target).parents().eq(0).attr("id");
      id = id.replace("main-nav-", "");

      // If a pulldown for this navigation item exists then slide it down
      if ($("#" + id + "-pulldown-menu").length > 0){
        // Prevent the redirect straight to the parent page
        event.preventDefault();

        // If this is the currently selected pulldown menu then slide it up and unassign the .active class
        if ($("#" + id + "-pulldown-menu").hasClass("active")){
          $("#" + id + "-pulldown-menu").slideUp(200);
          $("#" + id + "-pulldown-menu").removeClass("active");

          // Remove the .active class for the anchor clicked
          $(target).removeClass("active");
        }
        // If a pulldown menu IS active AND the ID of this pulldown menu does NOT match the ID of the pulldown requested
        else if ($(".pulldown-menu").hasClass("active") && $(".pulldown-menu.active").attr("id") != ("#" + id + "-pulldown-menu")){
          // Remove the .active class on the currently active anchor
          $("#main-nav a.active").removeClass("active");

          // Slide any active nav items up
          $(".pulldown-menu.active").removeClass("active").slideUp(200);

          // Slide the requested pulldown menu down
          $("#" + id + "-pulldown-menu").delay(400).slideDown(200).addClass("active");

          // Add the .active class to the anchor clicked
          $(target).addClass("active");
        }
        else
        {
          // Add the .active class to the anchor clicked
          $(target).addClass("active");

          // Slide the requested pulldown menu down
          $("#" + id + "-pulldown-menu").slideDown(200).addClass("active");
        }

        // Set the pulldown menu wrapper to active if there is a pulldown menu active to give the wrapper a border-bottom property
        if ($(".pulldown-menu").hasClass("active")){
          $("#main-nav-pulldown-menus").addClass("active");
        }
        else
        {
          $("#main-nav-pulldown-menus").removeClass("active");
        }
      }
    }
  }
};

dropdownShow = function(){
  // Dropdown menu functionality
  if (window.body_width < 970){
    // Hide the sub-navigation lists/dropdowns initially
    $(".dropdown-sibling").hide();
    $("#sub-content-left .sub-content-inner dl.subnav-list").hide();

    // Although show our first showcase, news and events items siblings (content)
    $(".active .dropdown-sibling").show();

    $(".subnav-dropdown-menu-anchor").each( function(){
      if($(this).hasClass("active")){
        $(this).find(".icon i.fa-caret-right").removeClass("fa-caret-right").addClass("fa-caret-down");
        $("#sub-content-left .sub-content-inner dl.subnav-list").show();
      }
    });
  }
  else
  {
    $(".subnav-dropdown-menu-anchor").find(".icon i.fa-caret-down").removeClass("fa-caret-down").addClass("fa-caret-right");
    $(".dropdown-sibling").show();
    $("#sub-content-left .sub-content-inner dl.subnav-list").show();  
  }
};

dropdownClick = function(event){
  // Only fire if we're using the mobile or tablet layouts but exit if we are using the tablet layout and the link clicked is in a pulldown
  if (window.body_width > window.md || (window.body_width > window.xs) ){ return false; }
  if( $(target).hasClass("mobile-nav-top-header") === true ){ return false; }

  // Get the target of the click event
  target = event.target;

  if ($(target).hasClass("subnav-dropdown-menu-anchor")){
    event.preventDefault();

    // Slide up/down this anchor's siblings (technically the h3 wrapper's)
    $(target).parent().siblings().slideToggle(200);
    $(target).parent().siblings().toggleClass("active");

    // Toggle the active class
    $(target).toggleClass("active");

    // If this is a homepage dropdown then make the top-level container active too or not
    if ($(target).parents().eq(1).hasClass("dropdown-item")){
      $(target).parents().eq(1).toggleClass("active");
    }

    // Change the carat to the correct type
    if ($(target).hasClass("active")){
      $(target).find("i.fa-caret-right").removeClass("fa-caret-right").addClass("fa-caret-down");
    }
    else
    {
      $(target).find("i.fa-caret-down").removeClass("fa-caret-down").addClass("fa-caret-right");
    }
  }
};

mobileNavButtonClick = function(event){
  // Get the target of the click event
  target = event.currentTarget;

  // If the anchor or the icon within the anchor is clicked then continue
  // if ($(target).attr("id") === "mobile-nav-button-anchor"){   
  //   // Is the navigation active? Act accordingly.
  //   if ($(target).hasClass("active")){
  //     $(target).removeClass("active");

  //     // Fade in our semi-opaque background overlay - look at mobileNavHide() for the function that actually takes care of hiding the navigation
  //     $("#mobile-nav-active-overlay").removeClass("active");

  //     // Slide in the navigation
  //     $("#main-nav-pulldown-menus").css({
  //       "left" : "-" + 66 + "%"
  //     });

  //     $("body").removeClass("mobile-nav-active");

  //     $("#main-nav-pulldown-menus").hide();
  //   }
  //   else
  //   {
  //     $(target).addClass("active");

  //     $("#main-nav-pulldown-menus").show();

  //     // Fade in our semi-opaque background overlay
  //     $("#mobile-nav-active-overlay").addClass("active");

  //     $("body").addClass("mobile-nav-active");

  //     // Slide out the navigation
  //     $("#main-nav-pulldown-menus").css({
  //       "left" : 0 + "%"
  //     });
  //   }
  // }
};

mobileNavItemShowClick = function(event){
  // Only fire if we're using the mobile layout
  if (window.body_width > window.xs){ return; }

  // Get the target of the click event
  target = event.currentTarget;

  if (window.body_width < window.xs){
    // If the target is the top-level heading of a pulldown AND that pulldown has child pages, if it doesn't then the anchor behaves as normal and refers you to the top-level page
    if ($(target).hasClass("mobile-nav-top-header") && $(target).parents().eq(2).children().length > 1){
      event.preventDefault();

      if ($(target).hasClass("active")){
        $(target).removeClass("active");

        $(target).parents().eq(1).siblings(".pulldown-menu-inner-subnav-row").slideUp(200);
      }
      else
      {
        // Toggle the active class
        $(target).toggleClass("active");

        // Toggle the sub-navigation dropdown
        $(target).parents().eq(1).siblings(".pulldown-menu-inner-subnav-row").slideDown(200);
      }

      // Change the carat to the correct type
      if ($(target).hasClass("active")){
        $(target).find(".icon i.fa-caret-right").removeClass("fa-caret-right").addClass("fa-caret-down");
      }
      else
      {
        $(target).find(".icon i.fa-caret-down").removeClass("fa-caret-down").addClass("fa-caret-right");
      }
    }
  }
};

mobileNavHide = function(overlay_click){
  function reset_pulldown(){
    /* Hide the pulldown and move it off the canvas so it will animate as expected and also make all top-level links inactive */
    $("#mobile-nav-active-overlay").removeClass("active");
    $("body").removeClass("mobile-nav-active");
    $("#mobile-nav-button-anchor").removeClass("active");
    $(".main-nav-anchor.active").removeClass("active");
    $("#main-nav-pulldown-menus.active").removeClass("active");
    $(".pulldown-menu.active").hide().removeClass("active");
    $("a.mobile-nav-top-header .icon i").removeClass("fa-caret-down").addClass("fa-caret-right");
  }

  if(window.body_width < window.xs && window.current_breakpoint == 'sm+' || overlay_click === true){
    reset_pulldown(); 
    $(".pulldown-menu-inner-subnav-row").hide();
    $("#main-nav-pulldown-menus").hide();
    $("#main-nav-pulldown-menus").css({ "left" : "-" + 66 + "%" });
    window.current_breakpoint = 'xs'; 
  }
  else if(window.body_width > window.xs && window.current_breakpoint == 'xs'){
    reset_pulldown();
    $(".pulldown-menu-inner-subnav-row").show();
    $("#main-nav-pulldown-menus").show();
    $("#main-nav-pulldown-menus").css({ "left" : "-" + 0 });
    window.current_breakpoint = 'sm+';
  }
};

backToTop = function(){
  var scroll_value = $(document).scrollTop();
    var viewport_size = $(window).height();

  if (scroll_value > viewport_size){
      $("#header").addClass("sticky-head").show();

      if (scroll_value > 640){
      $("#back-to-top").fadeIn(400);
      }
  }
  if (scroll_value < 640) {
      $("#back-to-top").fadeOut(400);
  }
};

$(document).ready( function(){
  window.xs = 1023;
  window.md = 992;

  // Get the window width
  window.body_width = $("body").width();
  window.header_offers_flex_base_html = $('#header-offers.flexslider').html();
  initMobileFlexsliders(window.body_width);
  mobileSurroundMargin();

  $("a").click( function(event){
   // pulldownClick(event);
    mobileNavButtonClick(event);
    mobileNavItemShowClick(event);
    backToTop();
  });
   

  $("#mobile-nav-active-overlay").click( function(){
    var overlay_click = true;
    mobileNavHide(overlay_click);
  });

  $(window).scroll( function(){
    backToTop();
  });

  backToTop();

  $("#back-to-top a").click(function(){
    $("html, body").animate({ scrollTop: 0 }, 400);
    return false;
  });

  // Initial load
  if (window.body_width < 767){
    window.current_breakpoint = "xs";

    $("#main-nav-pulldown-menus").hide();
    $(".pulldown-menu-inner-subnav-row").hide();
    $("#main-nav-pulldown-menus").css({ "left" : "-" + 66 + "%" });
    $(".subnav-dropdown-menu-anchor").find(".icon i.fa-caret-down").removeClass("fa-caret-down").addClass("fa-caret-right");
  }
  else{
    window.current_breakpoint = "sm+";
  }
});

$(window).load(function() {
  $('#masthead-inner.flexslider').flexslider({
    animation: "slide",
    directionNav: false
  });



  $('#brands-carousel-inner.flexslider').flexslider({
    animation: "slide",
    directionNav: false,
    controlNav : false,
    itemWidth: 210,
    minItems : 7,
    maxItems : 7,
    move : 7
  });


  /* Dropdown Panels */
  $(".dropdown-panel-button").click( function(event){
    event.preventDefault();
    var panel = $(this).attr('data-dropdown-panel-id');
    var ico = $(this).find('i');
    var state = $(this).hasClass('active');

    /* Toggle our panel according to its state */
    if( state == true ){
      $(this).removeClass('active');
      $(ico).removeClass('fa-caret-right').addClass('fa-caret-right');
      $('#' + panel).slideUp(400);
    }
    else{
      $(this).addClass('active');
      $(ico).removeClass('fa-caret-right').addClass('fa-caret-down');
      $('#' + panel).slideDown(400).addClass('active');
    }
  });
});

$(window).resize(function(){
  // Android Chrome bug causes the resize() event to fire on scroll(), we need to check to see if the window width has actually changed
  old_width = window.body_width;
  window.body_width = $("body").width();
  initMobileFlexsliders(window.body_width);
  mobileSurroundMargin();

  if (window.body_width > window.md && old_width != window.body_width){
    // Hide the navigation if pulled down
    dropdownShow();
    mobileNavHide();
  }
  else
  {
    dropdownShow();

    if ($("#mobile-nav-button-anchor").hasClass("active") == false){
      mobileNavHide();
    }
  }
});


// mobile nav
$(document).ready( function(){
   $("#mobile-nav-button").click(function(){
      $("#main-nav-pulldown-menus").addClass('active');
      $("body").addClass('nav-active');
      $(this).parent().addClass('active');
      $(".mobile-search-block").removeClass('active');
      $("#header-search").removeClass('active');
  });
  $("#mobile-nav-button-close").click(function(){
      $("#main-nav-pulldown-menus").removeClass('active');
      $(this).parent().removeClass('active');
      $("body").removeClass('nav-active');
      $('.pulldown-menu-inner').removeClass('active');
      $(this).parent().removeClass('active');
    
  });


  $(".pulldown-parent-page-header-row").click(function(){
      $(this).parent().addClass('active');
  });

  $(".mobile-submenu-back").click(function(){
      $('.pulldown-menu-inner').removeClass('active');
  });
});


